import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=0f2d3a9c&"
import script from "./FooterView.vue?vue&type=script&lang=js&"
export * from "./FooterView.vue?vue&type=script&lang=js&"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=0f2d3a9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports